import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-5 pt-28 text-center" data-testid="payment-cancel">
      <p className="font-college text-3xl text-navy">PAYMENT CANCELED</p>
      <p className="text-sm text-ink/60 mt-4">No charge was made. Your cart is exactly how you left it.</p>
      <Link
        to="/checkout"
        data-testid="cancel-back-to-checkout"
        className="inline-block mt-8 bg-navy text-paper font-college text-xl px-8 py-3 shadow-print hover:bg-red transition-colors"
      >
        BACK TO CHECKOUT
      </Link>
    </div>
  );
}
